export default __webpack_public_path__ + "static/media/download.085e2411.svg";